export default "__VITE_ASSET__BZEgeO52__"